import { Supplier } from "@/types/purchase";

export const getSupplierName = (supplier: Supplier) =>
    supplier.name || supplier?.shortName || supplier?.mobile || supplier?.code || '-';